import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import * as snackbarsActions from '../../../../../actions/snackbars';
import {selectOrganisation} from '../../../../../actions/organisation';
import SelectClientPanelView from './SelectClientPanelView';
import relationshipService from '../../../../../services/relationship/RelationshipService';
import {captureError} from '../../../../../utils/log';

function SelectClientPanelContainer(props) {
  const user = useSelector(globalState => globalState.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    if (props.isOpen) {
      relationshipService.getSubcontractorClientIds(user.id, props.organisation.organisationId)
        .then(response => {
          const matchingClients = user.userOrganisations
            .filter(organisation => response.includes(organisation.organisationId));

          setClients(matchingClients);
          setLoading(false);
        })
        .catch(error => {
          captureError('Error while getting client ids for a subcontractor', error);
          dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
        });
    }
  }, [props.isOpen]);

  function handleSelectClient(client) {
    dispatch(selectOrganisation(client));
    history.push(`/subcontractor/${props.organisation.organisationId}`);
  }

  return (
    <SelectClientPanelView
      organisation={props.organisation}
      clients={clients}
      onSelectClient={handleSelectClient}
      onClose={props.onClose}
      isOpen={props.isOpen}
      loading={loading}
    />
  );
}

SelectClientPanelContainer.propTypes = {
  organisation: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default SelectClientPanelContainer;
